import {
    validationForRequiredFields
  } from './util'

const initialState = {
  // initialValues
}
export default function FormValidationReducer(state = initialState, action) {
  switch (action.type) {
    case 'VALIDATE_COMPLETE_STORE':  
      const completeStore = action.store;
      const validationStatus = validationForRequiredFields(completeStore, action.updateType)
      action.validate(validationStatus)
      return completeStore;
    default:
      return state
  }
}
